export default __webpack_public_path__ + "static/media/fMaltoBuza21.0e12982e.png";